/**
 * Adapted from https://github.com/Swizec/useDimensions
 * License: MIT
 */
import { useState, useCallback, useLayoutEffect, useMemo } from 'react'
import { getDimensions, RAF, TypeDimensions } from '../modules/helpers'

// @ts-ignore
const _window: any = (typeof window !== 'undefined' && window) || global

type UseDimensionsHook = [any, TypeDimensions, HTMLElement]

interface UseDimensionsArgs {
    liveMeasure?: boolean
}

function useDimensions({ liveMeasure }: UseDimensionsArgs = {}): UseDimensionsHook {
    const [dimensions, setDimensions] = useState<any>({ width: 0 })
    const [node, setNode] = useState<any>(null)
    let didCancel = false

    const ref = useCallback((node) => {
        setNode(node)
    }, [])

    useLayoutEffect(() => {
        if (node) {
            const measure = () => RAF(() => !didCancel && setDimensions(getDimensions(node)))
            measure()

            if (liveMeasure) {
                _window.addEventListener('resize', measure)
                _window.addEventListener('scroll', measure)

                return () => {
                    _window.removeEventListener('resize', measure)
                    _window.removeEventListener('scroll', measure)
                }
            }
        }
        return () => {
            didCancel = true
        }
    }, [node])

    return useMemo(() => [ref, dimensions, node], [ref, Object.keys(dimensions), node])
}

export default useDimensions
